import React, { useState } from "react";
import { AGridColDef } from "../../../views/pages/manage/common/data-grid/ADataGridColDef";
import { ReactComponent as EyeIcon } from "assets/img/svg/eye.svg";
import { Tooltip } from "@mui/material";
import { gridStyles } from "../../../views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import ALoader from "../../../views/pages/manage/common/a-loader";
import ConfirmRejectionDialog from "../../../views/pages/manage/unAssigned/studentFinanceApproval/paymodeApproval/ConfirmRejectionDialog";
import AButton from "../../../views/pages/manage/common/form-fields-mui/AButton";
import CustomChip from "../../../views/pages/manage/common/customChip/CustomChip";
import { getStatusChipInfo, RemarkTooltipTitle, statusStyles } from "./utils";
import { useNavigateToGivenPath } from "../../../views/pages/manage/edpOps/studentDetails/paymentSummary/service";
import EnhanceDataGrid from "../../../views/pages/manage/common/data-grid/EnhanceDataGrid";
import { CourseDetailsPopupById } from "../../../views/pages/manage/unAssigned/studentCharges/common";
import { getFormatedDate } from "../../../views/pages/manage/unAssigned/concessionApproval/common";

const ApprovalRequestsList = ({
  approvalRequests,
  updateStatus,
  loading,
  isApprovePermission,
  paginationInfo,
  getApprovalRequests
}) => {
  const [updateStatusInfo, setUpdateStatusInfo] = useState(null);


  const navigateToGivenPath = useNavigateToGivenPath();

  const columns = [
    new AGridColDef('psid', 'PSID')
      .setMinWidth(120)
      .setFlex(1)
      .editable(false)
      .renderCellComponent(params => {
        return (
          <div
            onClick={() => navigateToGivenPath(`admin/edp/studentDetails/${params?.value}`)}
            style={{ color: "#00B0F5", cursor: "pointer" }}
          >
            {params?.value}
          </div>
        )
      }),

    new AGridColDef("id", "Transfer Request No.", false)
      .setMinWidth(150)
      .setFlex(1)
      .editable(false),

    new AGridColDef("studentName", "Student Name", false)
      .setMinWidth(160)
      .setFlex(1)
      .editable(false),

    new AGridColDef('businessArea', 'Business Area')
      .setMinWidth(130)
      .setFlex(1)
      .editable(false)
      .renderCellComponent(params => {
        const {outBusinessArea} = params?.row;
        const { label = outBusinessArea,  businessAreaDesc = outBusinessArea } = params?.value ?? {};
        return (
          <>
            <div className='mr-2'>{label}</div>
            <Tooltip title={businessAreaDesc}>
              <span><EyeIcon /></span>
            </Tooltip>

          </>
        )
      }),

    new AGridColDef("transferOutAppId", "Application ID", false)
      .setMinWidth(120)
      .setFlex(1)
      .editable(false),

    new AGridColDef('outCourseId', 'Course ID')
      .setMinWidth(130)
      .setFlex(1)
      .editable(false)
      .renderCellComponent(params => {
        return (
          <>
            <div className='mr-2'>{params?.value}</div>
            <CourseDetailsPopupById courseId={params?.value} cta={<EyeIcon />} />
          </>
        )
      }),

    new AGridColDef("enrollmentType", "Enrollment Type", false)
      .setMinWidth(140)
      .setFlex(1)
      .editable(false),

    new AGridColDef("transferType", "Transfer Type", false)
      .setMinWidth(130)
      .setFlex(1)
      .editable(false),

    new AGridColDef("effectiveDate", "Effective Date", false)
      .setMinWidth(130)
      .setFlex(1)
      .editable(false)
      .renderCellComponent((params) => getFormatedDate(params.value, false, "DD/MM/YYYY")),

    new AGridColDef('updatedOn', 'Last Updated On')
      .setMinWidth(150)
      .setFlex(1.2)
      .editable(false)
      .setValueGetter(params => {
        const dateAndTime = getFormatedDate(params?.value, false, "DD/MM/YYYY , hh:mm:A")?.split(",");
        return `${dateAndTime[0]} at ${dateAndTime[1]} by ${params?.row?.updatedBy}`
      }),

    new AGridColDef('approvedOn', 'Approved On')
      .setMinWidth(150)
      .setFlex(1.2)
      .editable(false)
      .setValueGetter(params => {
        const dateAndTime = getFormatedDate(params?.value, false, "DD/MM/YYYY , hh:mm:A")?.split(",");
        return params?.value ? `${dateAndTime[0]} at ${dateAndTime[1]}` : "-";
      }),

    new AGridColDef("status", "Request Status", false)
      .setMinWidth(180)
      .setFlex(1)
      .editable(false)
      .renderCellComponent((params) => {
        return (
          <>
            <CustomChip
              className="text-wrap mt-1 w-100 text-center"
              {...getStatusChipInfo(params?.row)}
            />
          </>
        );
      }),

    new AGridColDef("actions", "Action", false)
      .setMinWidth(400)
      .setFlex(1)
      .editable(false)
      .pinColumnLast(true)
      .renderCellComponent((params) => {
        const {
          psid,
          id,
          studentName,
          transferOutAppId,
          isL1Approver,
          isL2Approver,
          approvalStatus
        } = params.row;

        const isL1Pending = approvalStatus === 'L1_PENDING';
        const isL2Pending = approvalStatus === 'L2_PENDING';

        const actionsEnabled = (isL1Pending && isL1Approver || isL2Pending && isL2Approver)

        return (
          <div className="d-flex">
            {isApprovePermission &&
              <>
                <AButton
                  variant="danger_filled"
                  size="xs"
                  className="no-ml-btn"
                  onClick={() => setUpdateStatusInfo({
                    approvalAction: "REJECT",
                    applicationId: transferOutAppId,
                    dialgoInfo: {},
                    psid,
                    transferReqNo: id,
                    dialogInfo : {
                      remarksMandatory : true
                    }
                  })}
                  disabled={!actionsEnabled}
                >
                  Reject
                </AButton>

                <AButton
                  variant="primary_filled"
                  size="xs"
                  onClick={() => updateStatus({
                    approvalAction: "APPROVE",
                    applicationId: transferOutAppId,
                    psid,
                    transferReqNo: id,
                  })}
                  disabled={!actionsEnabled}
                >
                  Approve
                </AButton>

                <AButton
                  variant="outline"
                  textColor={"#000"}
                  outlineVariantColor={"#CCC"}
                  disabled={!actionsEnabled}
                  size="xs"
                  onClick={() => setUpdateStatusInfo({
                    approvalAction: "CORRECTION",
                    applicationId: transferOutAppId,
                    psid,
                    transferReqNo: id,
                    dialogInfo: {
                      heading: "Send back for correction",
                      subHeading: `Request No : ${id}`,
                      proceedBtn: <button style={{ backgroundColor: '#00B0F5', width: 'fit-content', color: '#FFF', border: 'none' }}>Send back for correction</button>,
                      remarksMandatory : true
                    }

                  })}
                >
                  Send for Correction
                </AButton>
              </>
            }

            <EyeIcon
              onClick={() => navigateToGivenPath(`admin/viewTransferDetails?psid=${psid}&requestId=${id}&applicationId=${encodeURIComponent(transferOutAppId)}&studentName=${encodeURIComponent(studentName)}&isBmApproval=${encodeURIComponent(true)}`)}
              className="ml-2 mt-2 cursor"
            />
          </div>

        )
      }),
  ];

  const { totalRecords, currPageNo, currPageSize } = paginationInfo;

  return (
    <>
      {loading && <ALoader position="fixed" />}
      <EnhanceDataGrid
        removeWrapperContainer
        paginationModel={{ page: currPageNo, pageSize: currPageSize }}
        rows={approvalRequests || []}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        loading={false}
        rowCount={totalRecords}
        nextButtonHandler={(pageNo, pageSize) => getApprovalRequests({ pageNo, pageSize })}
        currentPage={currPageNo}
        sx={gridStyles}
        autoHeight
        pinLastColumn
      />

      <ConfirmRejectionDialog
        updateStatusInfo={updateStatusInfo}
        setUpdateStatusInfo={setUpdateStatusInfo}
        updateStatus={updateStatus}
        dialogInfo={updateStatusInfo?.dialogInfo}
      />


    </>
  );
};

export default ApprovalRequestsList;
